"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBytes = formatBytes;
function formatBytes(fileSizeBytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!+fileSizeBytes) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(fileSizeBytes) / Math.log(k));
  return "".concat(parseFloat((fileSizeBytes / Math.pow(k, i)).toFixed(dm))).concat(sizes[i]);
}